import moment from "moment";

moment.locale("pt-br");

export function formatarTempoChecagem(dataChecagem?: string | null, latencia?: string | null): string {
	if (!dataChecagem) return "";

	const agora = moment();
	const dataCheck = moment(dataChecagem, "DD/MM/YYYY HH:mm:ss");
	const diferencaMinutos = agora.diff(dataCheck, "minutes");

	const latenciaTexto = latencia ? `${latencia}` : "";

	if (diferencaMinutos < 60) {
		return `${dataCheck.fromNow()} ◦ ${latenciaTexto}`;
	} else {
		return `${dataChecagem} ◦ ${latenciaTexto}`;
	}
}
